<template>
    <div class="star-rating__container">
        <p v-if="label" v-text="label" class="star-rating__label"></p>
        <div class="star-rating__stars-wrapper">
            <div v-for="(star, index) in stars"
                 :key="index"
                 :class="getStarClass(star.variant, star.number)"
                 @click="handleStarClick(star.number)"
                 @mouseover="handleHoverEvent(star.number)"
                 @mouseleave="handleMouseLeaveEvent">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StarRatingField',
    data() {
        return {
            stars: [],
            variants: [
                'a',
                'b',
                'c',
                'd',
                'e',
            ],
            hoverValue: 0,
        };
    },
    props: {
        label: {
            type: String,
            required: false,
        },
        maxStars: {
            type: Number,
            default: 5,
        },
        value: {
            type: Number,
        },
    },
    mounted() {
        for (let i = 1; i <= this.maxStars; i++) {
            this.stars.push({ variant: this.getVariantForStarNumber(i), number: i });
        }
    },
    methods: {
        getStarClass(variant, starNumber) {
            let preClass = '';

            if (this.hoverValue) {
                preClass = starNumber <= this.hoverValue ? 'star-rating__star--filled ' : preClass;
            } else {
                preClass = starNumber <= (this.value || 0) ? 'star-rating__star--filled ' : '';
            }

            return `${preClass} star-rating__star star-rating__star-${variant.toLowerCase()}`;
        },

        getVariantForStarNumber(i) {
            const key = (i % 5);
            return this.variants[key];
        },

        handleStarClick(number) {
            this.$emit('input', number);
        },

        handleHoverEvent(number) {
            this.hoverValue = number;
        },

        handleMouseLeaveEvent() {
            this.hoverValue = 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.star-rating {
    &__container {
        display: block;
        @media (min-width: 400px){
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
    &__label {
        text-align: left;
    }
    &__stars-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    &__star {
        background-repeat: no-repeat;
        background-position: center;
        background-size: auto;
        height: 32px;
        width: 32px;
        &:hover {
            cursor: pointer;
        }
        &-a {
            background-image: url('~@/assets/images/decoration/stars/star-a.svg');
        }
        &-b {
            background-image: url('~@/assets/images/decoration/stars/star-b.svg');
        }
        &-c {
            background-image: url('~@/assets/images/decoration/stars/star-c.svg');
        }
        &-d {
            background-image: url('~@/assets/images/decoration/stars/star-d.svg');
        }
        &-e {
            background-image: url('~@/assets/images/decoration/stars/star-e.svg');
        }

        &--filled {
            &.star-rating__star-a {
                background-image: url('~@/assets/images/decoration/stars/star-a-filled.svg');
            }

            &.star-rating__star-b {
                background-image: url('~@/assets/images/decoration/stars/star-b-filled.svg');
            }

            &.star-rating__star-c {
                background-image: url('~@/assets/images/decoration/stars/star-c-filled.svg');
            }

            &.star-rating__star-d {
                background-image: url('~@/assets/images/decoration/stars/star-d-filled.svg');
            }

            &.star-rating__star-e {
                background-image: url('~@/assets/images/decoration/stars/star-e-filled.svg');
            }
        }
    }
}
</style>
